import { render, staticRenderFns } from "./mSideSection.vue?vue&type=template&id=33f3f1d2&scoped=true"
import script from "./mSideSection.vue?vue&type=script&lang=ts"
export * from "./mSideSection.vue?vue&type=script&lang=ts"
import style0 from "./mSideSection.vue?vue&type=style&index=0&id=33f3f1d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f3f1d2",
  null
  
)

export default component.exports